import React, { useState } from "react"
import Link from "next/link"
import MobileMenu from "./MobileMenu"
import { useRouter } from "next/router"
import { useEffect } from "react"
import Image from "next/image"

import {
  useTranslation,
  useLanguageQuery,
  LanguageSwitcher,
} from "next-export-i18n"

const Navbar = () => {
  const { t } = useTranslation()
  const [query] = useLanguageQuery()

  return (
    <div className={`w-full top-0 sticky z-40 `}>
      <div className=" block xl:hidden">
        <MobileMenu />
      </div>
      <div className="w-full mx-auto hidden xl:block bg-lightBlue  px-4 py-4 z-50 shadow-lg transition-all duration-500 transform">
        <div>
          <ul className=" flex justify-between  ">
            <div>
              <li className="flex self-center">
                <Link href={{ pathname: "/", query: query }}>
                  <a className="transform hover:scale-110 transition-all duration-300 pl-5">
                    <Image
                      src="/images/ERVCClogo.png"
                      width={280}
                      height={70}
                      alt="ERVCC logo"
                    />
                  </a>
                </Link>
              </li>
            </div>

            <div className=" flex justify-between  ">
              <li
                className={`flex-col self-center `}
              >

                <div className="flex justify-center">
                  <Link
                    href={{
                      pathname: t(
                        "register_for_a_phone_or_video_call_here.route"
                      ),
                      query: query,
                    }}
                  >
                    <a className="text-sm text-center lg:text-base  font-semibold text-white hover:text-white bg-primary transition-all hover:bg-secondary hover:shadow-lg rounded-full px-4 py-2 md:px-10 md:py-3 cursor-pointer">
                      {t("register_for_a_phone_or_video_call_here.text")}
                    </a>
                  </Link>
                {/* </div> */}
                </div>
                <div>
                <a
                  className={`flex justify-center pt-1 text-dark hover:text-secondary px-4 transition-all  `}
                >
                  {t("open_7_days_a_week")}
                </a>
                </div>
              </li>
              <li
                className={`flex self-center border-b-4 border-transparent pb-2 -mb-2`}
              >
                <a
                  className={` text-dark hover:text-secondary px-4 transition-all  `}
                ></a>
              </li>
              <li
                className={`flex self-center border-b-4 border-transparent !cursor-pointer `}
              >
                <span
                  style={
                    query?.lang == "en"
                      ? { borderBottom: "3px solid black" }
                      : { borderBottom: "none" }
                  }
                >
                  <LanguageSwitcher className="text-xl" lang="en">
                    EN
                  </LanguageSwitcher>
                </span>
                <span className="px-2">|</span>
                <span
                  style={
                    query?.lang == "fr"
                      ? { borderBottom: "3px solid black" }
                      : { borderBottom: "none" }
                  }
                >
                  <LanguageSwitcher lang="fr">FR</LanguageSwitcher>
                </span>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Navbar
